export default "__VITE_ASSET__CWBDxcPW__"